import React, { FC } from 'react';
import styled from 'styled-components';

const StyledNavigationButton = styled.div<{ color: string }>`
  height: 65px;
  width: 100%;
  background-color: ${({ color }) => color};
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 20px 0 0 0;
  :hover {
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const ArrowImage = styled.img`
  display: block;
  margin: 15px 20px 15px 50px;
`;

const IconImage = styled.img`
  display: block;
  margin: 15px 10px 15px 20px;
`;

const Text = styled.p`
  color: #ffffff;
  font-size: 18px;
  max-width: 230px;
  width: 100%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
  margin-bottom: 0px;
`;

export const NavigationButton: FC<{
  text: string;
  color: string;
  icon: string;
  arrow: string;
}> = ({ text, color, icon, arrow }) => {
  return (
    <StyledNavigationButton color={color}>
      <IconImage src={icon} />
      <Text>{text}</Text>
      <ArrowImage src={arrow} />
    </StyledNavigationButton>
  );
};
